import React, { Component } from "react";
import { connect } from "react-redux";
import * as notificationActions from "../../_actions/notificationActions";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import InfiniteScroll from "react-infinite-scroller";
import AdvancedTimeline from "../UI/AdvancedTimeline";
import getNotificationsList from "../../_selectors/userSelectors/getNotificationsList";
import getNotificationsLastResult from "../../_selectors/userSelectors/getNotificationsLastResult";
import getMyNotificationsCount from "../../_selectors/userSelectors/getMyNotificationsCount";

class Notifications extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getNotifications,
      notificationCount,
      markAllRead
    } = this.props;
    updateHeader({
      title: "Notifications",
      description: ""
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Notifications", link: "/notifications" }
    ]);
    getNotifications();
    if (notificationCount > 0) {
      markAllRead();
    }
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { notifications, lastResult } = this.props;
    return (
      <Section>
        <div className="row">
          <div className="col-md-12">
            <InfiniteScroll
              pageStart={0}
              loadMore={this.loadMoreItems}
              hasMore={lastResult !== null}
              initialLoad={false}
              loader={
                <div
                  className="loader"
                  style={{
                    textAlign: "center",
                    lineHeight: "50px",
                    color: "#000",
                    fontSize: "1.5em",
                    marginTop: "1em"
                  }}
                >
                  Loading Notifications
                </div>
              }
            >
              {notifications.length === 0 ? (
                <PageSubTitle center>
                  <h3>No New Notifications</h3>
                </PageSubTitle>
              ) : (
                <AdvancedTimeline items={notifications} />
              )}
            </InfiniteScroll>
          </div>
        </div>
      </Section>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notifications: getNotificationsList(state),
  lastResult: getNotificationsLastResult(state),
  notificationCount: getMyNotificationsCount(state)
});

const mapDispatchToProps = dispatch => ({
  getNotifications: () => dispatch(notificationActions.getNotificationsList()),
  loadMore: payload =>
    dispatch(notificationActions.loadMoreNotifications(payload)),
  markAllRead: () => dispatch(notificationActions.markAllNotificationsAsRead())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/_components/Notifications/index.js